declare const __UMAMI_WEBSITE_ID__: string | undefined;
declare const __UMAMI_HOST__: string | undefined;

declare global {
  interface Window {
    umami?: {
      track: (event: string, data?: Record<string, unknown>) => void;
    };
  }
}

let bootstrapped = false;

export function bootstrapAnalytics(): void {
  if (bootstrapped) return;
  if (typeof window === "undefined") return;
  // The build.ts `define` block replaces these identifiers at production
  // build time. In dev (`bun --hot`) those defines aren't applied, so the
  // bare names would throw ReferenceError — use typeof to probe safely.
  const id = typeof __UMAMI_WEBSITE_ID__ !== "undefined" ? __UMAMI_WEBSITE_ID__ : "";
  const host =
    typeof __UMAMI_HOST__ !== "undefined" && __UMAMI_HOST__
      ? __UMAMI_HOST__
      : "https://analytics.holymolylab.com";
  if (!id) return;

  bootstrapped = true;

  const script = document.createElement("script");
  script.defer = true;
  script.src = `${host}/script.js`;
  script.dataset.websiteId = id;
  document.head.appendChild(script);
}

export function track(event: string, data?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  window.umami?.track(event, data);
}
